import { _BaseListButtonData, IListButtonData } from "./_base-list-button";

export class ListButtonSave 
    extends _BaseListButtonData
{
    protected constructor(buttonData?: IListButtonData | null){
        super(buttonData ?? null)
    }

    static create(buttonData?: IListButtonData | null): ListButtonSave {
        return new ListButtonSave(buttonData);
    }
}
